import { render } from "./TheIdeal.vue?vue&type=template&id=200bd6c4"
import script from "./TheIdeal.vue?vue&type=script&lang=js"
export * from "./TheIdeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__